import {PEOPLE} from "../actions/types";

const initialState ={
    people:[]
}

export default function(state = initialState,action){
    switch(action.type){
        case PEOPLE:
        return{
            people:action.payload,
        }
        
        default:
        return state;
    }
}